export const deepCopy = object => JSON.parse(JSON.stringify(object));
